import { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../hooks/use-fetch';

import { Dialog, Transition } from '@headlessui/react';
import Form, { Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import Select from '@atlaskit/select';

import ErrorsBlock from '../../../components/errors';

export default function AddEquipment({closeModal, isOpen, reloadTable, producersList}) {
  const {t} = useTranslation();
  const [producerId, setProducerId] = useState('');
  const [modelsList, setModelsList] = useState([]);
  const [errors, setErrors] = useState([]);

  const [{response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError}, doFetchItemSave] = useFetch(`/directories/equipment_items`);
  const [{response: modelsResponse, isLoading: modelsIsLoading, error: modelsError}, doFetchModels] = useFetch(`/directories/equipment_models?producer_id=${producerId}`);

  const onSaveClick = (formData) => {
    doFetchItemSave({
      method: 'POST',
      data: {
        data: {
          name: formData.name,
          factory_number: formData.factory_number,
          inventory_number: formData.inventory_number,
          equipment_model_id: formData.model.value,
          balance_date: formData.balance_date,
          release_date: formData.release_date,
          qrcode: formData.qrcode,
          producer_id: formData.producer.value
        }
      }
    });
  };

  useEffect(() => {
    if(producerId == '') {
      return
    }
    doFetchModels()
  },[producerId])

  useEffect(() => {
    if(!modelsResponse) {
      return;
    }
    const newModelsList = [];    
    modelsResponse.data.forEach(item => {
      newModelsList.push({label: item.attributes.name, value: item.id})
    });
    setModelsList(newModelsList);
  },[modelsResponse]);

  useEffect(() => {
    if (!itemSaveResponse) {
      return;
    }
    if (itemSaveResponse) {
      closeModal();
    }
    reloadTable();
  }, [itemSaveResponse]);

  useEffect(() => {
    if (itemSaveError) {
      setErrors(itemSaveError.errors)
    }
  }, [itemSaveError]);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={closeModal}
      >
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        <div className="min-h-screen px-4 text-center">
          {/* <span className="inline-block h-screen align-middle" aria-hidden="true">&#8203;</span> */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full lg:w-1/2 p-6 mt-32 my-8 text-left align-middle transition-all transform bg-white shadow-xl rounded">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
              >
                {t('adding_equipment')}
              </Dialog.Title>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  {t('adding_equipment_form_text')}
                </p>
              </div>
              {errors.length > 0 ? <ErrorsBlock errors={errors}/> : ''}
              <Form onSubmit={data => onSaveClick(data)}>
                {({ formProps }) => (
                  <form {...formProps}>
                    <div className="grid md:grid-cols-2 gap-4 text-sm">
                      <Field name="name" defaultValue="" label={t('equipment_name')} isRequired>
                        {({ fieldProps }) => <TextField {...fieldProps} />}
                      </Field>
                      <Field name="inventory_number" defaultValue="" label={t('equipment_inventory_number')} isRequired>
                        {({ fieldProps }) => <TextField {...fieldProps} />}
                      </Field>
                      <Field name="producer" defaultValue={producersList.find(it => it.value == producerId) || ""} label={t('equipment_producer')} isRequired>
                        {({ fieldProps }) => <Select {...fieldProps} className="text-sm" options={producersList} onChange={(e) => setProducerId(e.value)} />}
                      </Field>
                      <Field name="model" defaultValue="" label={t('equipment_model')} isRequired>
                        {({ fieldProps }) => <Select {...fieldProps} className="text-sm" options={modelsList}/>}
                      </Field>
                      <Field name="factory_number" defaultValue="" label={t('equipment_factory_number')} isRequired>
                        {({ fieldProps }) => <TextField {...fieldProps} />}
                      </Field>
                      <Field name="qrcode" defaultValue="" label={t('qrcode')}>
                        {({ fieldProps }) => <TextField {...fieldProps} />}
                      </Field>
                    </div>
                    <div className="flex justify-between mt-8">
                      <button 
                        type="submit" 
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                      >
                        {t('save')}
                      </button>
                      <button 
                        onClick={() => closeModal()}
                        type="button" 
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-900 bg-gray-100 border border-transparent rounded hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                      >
                        {t('cancel')}
                      </button>
                    </div>
                  </form>
                )}
              </Form>
            </div>
          </Transition.Child>
        </div>
        
      </Dialog>
    </Transition>
  )
}
